module.exports = __webpack_public_path__ + "media/plains-ambience.91939a72.mp3";